export default {"src":"/_next/static/media/icon-glyph.b6549dee.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};